"use strict";
jQuery(function ($) {
    // top-fv スライダー（Swiper）
    const fvSliderEl = document.querySelector("#js-fv-slider");
    if (fvSliderEl && typeof Swiper !== "undefined") {
        new Swiper("#js-fv-slider", {
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 500,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".top-fv__pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".top-fv__arrow--next",
                prevEl: ".top-fv__arrow--prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.15,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 1.25,
                    spaceBetween: 40,
                },
            },
        });
    }

    // recruit スライダー（職場の雰囲気・自動スクロール）
    const recruitSliderEl = document.querySelector("#js-recruit-slider");
    if (recruitSliderEl && typeof Swiper !== "undefined") {
        new Swiper("#js-recruit-slider", {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 16,
            speed: 4000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                },
            },
        });
    }

    // ハンバーガーメニュー（fixed + top でロック、閉じるとき scrollTo で位置を復元）
// ハンバーガーメニュー
const $hamburger = $('.js-hamburger');
const $drawer = $('.js-drawer');

function resetDrawerAccordions() {
    $drawer.find('.drawer__list--accordion').removeClass('is-open');
    $drawer.find('.js-drawer-accordion').attr('aria-expanded', 'false');
    $drawer.find('.drawer__sublists').prop('hidden', true);
}

$hamburger.on('click', function () {
    $hamburger.toggleClass('is-active');
    $drawer.toggleClass('is-active');
    document.body.classList.toggle('is-drawer-open');
    if (!$drawer.hasClass('is-active')) {
        resetDrawerAccordions();
    }
});

// ドロワー内リンクのクリックで閉じる
$drawer.find('a[href]').on('click', function () {
    $hamburger.removeClass('is-active');
    $drawer.removeClass('is-active');
    document.body.classList.remove('is-drawer-open');
    resetDrawerAccordions();
});

// ドロワー内アコーディオン（事業概要）
$('.js-drawer-accordion').on('click', function () {
    const $btn = $(this);
    const $parent = $btn.closest('.drawer__list--accordion');
    const $sub = $parent.find('.drawer__sublists');
    const wasOpen = $parent.hasClass('is-open');
    $parent.toggleClass('is-open');
    $btn.attr('aria-expanded', wasOpen ? 'false' : 'true');
    $sub.prop('hidden', wasOpen);
});

    // Contact Form 7: data-default-category が指定されていたらラジオを初期選択
    document.querySelectorAll(".contact-form-section[data-default-category]").forEach(function (section) {
        const target = section.dataset.defaultCategory;
        if (!target) return;
        const radios = section.querySelectorAll('input[type="radio"]');
        radios.forEach(function (radio) {
            if (radio.value === target) {
                radio.checked = true;
                radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    });

    // Contact Form 7: バリデーションエラー時にエラー表示部位までスクロール
    document.addEventListener("wpcf7invalid", function (event) {
        // event.target は form.wpcf7-form 自身なので、closest か直接使う
        const form = event.target.closest("form") || event.target;

        // CF7はイベント発火直後にtipをDOMへ追加するため setTimeout(0) が必要
        setTimeout(function () {
            const tipOrInvalid = form.querySelector(".wpcf7-not-valid-tip")
                || form.querySelector(".wpcf7-not-valid");
            const target = tipOrInvalid?.closest(".contact-form__row") || tipOrInvalid;
            if (!target) return;

            const headerEl = document.querySelector(".header");
            const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
            const top = target.getBoundingClientRect().top + window.scrollY - headerBottom;
            window.scrollTo({
                top: Math.max(0, top - 20),
                behavior: "smooth",
            });
        }, 0);
    });

    // アンカーリンク（スムーススクロール + ヘッダー高さ考慮）
    const headerEl = document.querySelector(".header");
    document.querySelectorAll('a[href*="#"]').forEach(function (link) {
        link.addEventListener("click", function (e) {
            const href = link.getAttribute("href");
            const hashMatch = href && href.match(/#(.+)$/);
            if (!hashMatch) return;
            const target = document.getElementById(hashMatch[1]);
            if (!target) return;
            e.preventDefault();
            // ヘッダー下端（PC の top: 32px 含む）を基準にオフセット
            const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
            const top = target.getBoundingClientRect().top + window.scrollY - headerBottom;
            window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        });
    });
});
